import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import * as prismicActions from '../redux/actions/prismicActions'
import PrismicReact from 'prismic-reactjs'
import MetaTags from '../components/MetaTags';
import LoadingOverlay from '../components/LoadingOverlay';
import htmlSerializer from '../plugins/htmlSerializer';


class Contact extends Component {
  	constructor(props) {
        super(props) 
        this.state = {
          doc: null,
          notFound: false,
        }
    }

    componentWillMount() {
        this.findPage(this.props)
    }
    
    componentWillReceiveProps(props) {
        this.findPage(props)
    }
    
    findPage(props) {
        if(props.prismicData) {
            let doc = props.prismicData.results.find(result => result.type === 'contact_page') 
            
            this.setState({doc})
            props.getActiveDoc(doc)
        }
    }

    render(){
			if(this.state.doc) {
				const {
					prismicCtx
        } = this.props
        // window.document.querySelector('html').classList.add('ready');
        const document = this.state.doc
        const docData = document.data
        const leftBlock = docData.left_block[0]
        const rightBlock = docData.right_block[0]

        return(
            <main id="contactPage" className="contact-page">
              <MetaTags 
                title={`${docData.meta_title ? docData.meta_title : 'AltaVie'}`}
                description={`${docData.meta_description ? docData.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
              />
								<div className="hero-image-banner" style={{backgroundImage: `url(${docData.banner_image.url})`}}></div>	
								<div className="container">
									<div className="flexbox">
										<div className="flex-item three-quarters">
											<div className="contact-left">
												<div className="left-title">
													<h1>{PrismicReact.RichText.asText(leftBlock.title)}</h1>
												</div>
												<div className="left-body">
													{PrismicReact.RichText.render(leftBlock.information, prismicCtx.linkResolver)}
												</div>
												<div className="left-contact-wrapper"></div>
											</div>
										</div>

										{/* <div className="flex-item half">
											<div className="contact-right">
												<div className="right-title">
													<h1>{PrismicReact.RichText.asText(rightBlock.title)}</h1>
												</div>
												<div className="right-body">
													{PrismicReact.RichText.render(rightBlock.description, prismicCtx.linkResolver)}
												</div>
												<div className="right-button">
													<Link to={PrismicReact.Link.url(rightBlock.faq_link, prismicCtx.linkResolver)} className="button button-large">
														{rightBlock.faq_link_name}
													</Link>
												</div>
                        <div className="right-cta">
                          {PrismicReact.RichText.render(rightBlock.cta_social, prismicCtx.linkResolver, htmlSerializer)}
                        </div>
											</div>
										</div> */}
									</div>
								</div>
								
								
            </main>
				)
			}else{
				return (
					<LoadingOverlay/>
				)
			}
    }
}

const mapStateToProps = state => ({
    locale: state.global.locale,
    prismicCtx: state.prismic.prismicCtx,
    prismicData: state.prismic.prismicData,
    activeDoc: state.prismic.activeDoc,
})
  
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { getActiveDoc: prismicActions.getActiveDoc, },
        dispatch
    )
  
export default connect(mapStateToProps, mapDispatchToProps)(Contact)



// WEBPACK FOOTER //
// ./src/pages/ContactPage.js